const NotFound = () => {
    return ( 
        <div>
            <h3>Nothing here</h3>
        </div>
     );
}

export default NotFound;